import { useEffect } from "react";
import { Row, Col, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { BaseForm } from "components/common/forms/BaseForm";
import LogoContainer from "pages/publicPages/Login/LogoContainer";
import { TimeOutIcon } from "config/IconConfig";
import { BackgroundWrapper, FormWrapper, LoginWrapper, Wrapper } from "pages/publicPages/Login/styles";
import * as S from "./styles";

export const SessionExpiredPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  return (
    <Wrapper>
      <BackgroundWrapper>
        <LoginWrapper>
          <FormWrapper>
            <LogoContainer />
        <div className="logo-container">
          <Image src={TimeOutIcon} preview={false} alt="logo" height={50} />
        </div>
        <div style={{ textAlign: "center" }}>
          <S.FormTitle>YOUR SESSION HAS BEEN EXPIRED</S.FormTitle>
        </div>
        <div style={{ textAlign: "center" }}>
          <S.InitialInfo>Please login again to continue</S.InitialInfo>
        </div>
        <Row gutter={24}>
          <Col span={24}>
            <BaseForm.Item noStyle>
              <S.SubmitButton type="primary" onClick={() => navigate("/")}>
                LOGIN AGAIN
              </S.SubmitButton>
            </BaseForm.Item>
          </Col>
        </Row>
      </FormWrapper>
    </LoginWrapper>
    </BackgroundWrapper>
    </Wrapper>
  );
};

export default SessionExpiredPage;
